import React from 'react';
import Sidebar from '../pages/sidebar/Sidebar';
import { Outlet } from 'react-router-dom';

const MainLayout = () => (
  <div className='layoutSet' style={{ display: 'flex', fontFamily: "DM Sans" }}>
    <Sidebar />
    <div style={{ flex: 1, padding: '20px' }}>
      <Outlet />
    </div>
  </div>
);

export default MainLayout;
